module.exports = __webpack_public_path__ + "img/cooperate_title.320cb21d.png";